import api from './api'
import fetch from 'isomorphic-fetch'
import {
  POSTS_FAILURE,
  POSTS_SUCCESS,
  POSTS_REQUESTING,
  POST_FAILURE,
  POST_SUCCESS,
  POST_REQUESTING,
  PAGE_FAILURE,
  PAGE_SUCCESS,
  PAGE_REQUESTING,
  SITE_META_REQUESTING,
  SITE_META_SUCCESS,
  SITE_META_FAILURE,
  // SITE_TAGS_FAILURE,
  SITE_TAGS_SUCCESS,
  SITE_TAGS_REQUESTING,
  // SITE_CATEGORIES_FAILURE,
  SITE_CATEGORIES_SUCCESS,
  SITE_CATEGORIES_REQUESTING,
  // SITE_MEDIA_CATEGORIES_FAILURE,
  SITE_MEDIA_CATEGORIES_SUCCESS,
  SITE_MEDIA_CATEGORIES_REQUESTING,
} from './actionTypes'
import { API, CONTACT_FORM_URL } from './constants'
import { sanitizePost } from './post'

// TODO: Temporary non-paging hack
const getTags = () => api(`${API}/tags?per_page=100`)
const getCategories = () => api(`${API}/categories?per_page=100`)

// Using the Enhanced Media Library plugin
const getMediaCategories = () => api(`${API}/media_category`)

export const getSiteMeta = (isServer) => async (dispatch) => {
  await Promise.all([
    dispatch({ type: SITE_META_REQUESTING }),
    dispatch({ type: SITE_TAGS_REQUESTING }),
    dispatch({ type: SITE_CATEGORIES_REQUESTING }),
    dispatch({ type: SITE_MEDIA_CATEGORIES_REQUESTING }),
  ])

  try {
    const [tagsRes, categoriesRes, mediaCategoriesRes] = await Promise.all([
      getTags(),
      getCategories(),
      getMediaCategories(),
    ])

    dispatch({ type: SITE_TAGS_SUCCESS, data: tagsRes.data })
    dispatch({ type: SITE_CATEGORIES_SUCCESS, data: categoriesRes.data })
    dispatch({
      type: SITE_MEDIA_CATEGORIES_SUCCESS,
      data: mediaCategoriesRes.data,
    })
    dispatch({ type: SITE_META_SUCCESS })

    return {
      tags: tagsRes.data,
      categories: categoriesRes.data,
      mediaCategories: mediaCategoriesRes.data,
    }
  } catch (error) {
    // TODO: We do not gracefully handle the individual errors
    //console.error(error)
    dispatch({ type: SITE_META_FAILURE, error: error })
  }
}

// Use slug for tag or category and this will look up the corresponding id
// to build the proper filters
export const getPosts = (options) => (dispatch, getState) => {
  const { categories, tags, ids } = options

  let filters = ['per_page=100', 'orderby=date']
  if (tags) {
    const storeTags = getState().tags.items

    const tagIds = storeTags
      .filter((t) => tags.includes(t.slug))
      .map((item) => item.id)
    if (tagIds.length) {
      filters.push(`tags=${tagIds.join(',')}`)
    }
  }

  if (categories) {
    const storeCategories = getState().categories.items
    //console.log({ categories, storeCategories })

    const categoryIds = storeCategories
      .filter((t) => categories.includes(t.slug))
      .map((item) => item.id)
    if (categoryIds.length) {
      filters.push(`categories=${categoryIds.join(',')}`)
    }
  }

  if (ids) {
    filters.push(`include=${ids.join(',')}`)
  }

  return Promise.resolve(dispatch({ type: POSTS_REQUESTING }))
    .then(() => api(`${API}/posts?${filters.join('&')}`))
    .then((res) => dispatch({ type: POSTS_SUCCESS, data: res.data }))
    .catch((err) => dispatch({ type: POSTS_FAILURE, error: err }))
}

export const getPost = ({ slug }) => async (dispatch) => {
  await Promise.resolve(dispatch({ type: POST_REQUESTING }))
  try {
    const res = await api(`${API}/posts?slug=${slug}`)
    //console.log(res.data)
    if (res.data) {

    dispatch({ type: POST_SUCCESS, data: sanitizePost(res.data) })
    return sanitizePost(res.data)
    } else {
      dispatch({ type: POST_FAILURE, error: 'No data' })
    }
  } catch (error) {
    dispatch({ type: POST_FAILURE, error: error })
  }
}

// Note: this only supports top-level pages
export const getPage = ({ slug }) => async (dispatch) => {
  await Promise.resolve(dispatch({ type: PAGE_REQUESTING }))
  let id = slug
  try {
    if (slug === '/' || slug === '_next' || slug.indexOf('/_next') === 0) {
      //console.log('Rewriting slug to home')
      id = 'home'
    } else if (slug.match(/^\//)) {
      id = slug.split('/')[1]
    }
    //console.log(`The requested slug update is - :${id}:`)
    // if (slug === '_next') return Promise.resolve()
    //console.log(`Requesting: ${API}/pages?slug=${id}`)
    const res = await api(`${API}/pages?slug=${id}`)

    dispatch({ type: PAGE_SUCCESS, data: sanitizePost(res.data) })
    return res.data
  } catch (error) {
    dispatch({ type: PAGE_FAILURE, error: error })
  }
}

export const submitContactForm = (data) => {
  const payload = {
    ...data,
    referrer: window.location.href,
  }

  // TODO: api was throwing errors even with successful POSTS. This works
  // correctly, but it's overkill to have multiple xhr libs
  return fetch(CONTACT_FORM_URL, {
    method: 'POST',
    mode: 'no-cors',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(payload),
  })
}
